/** Parse CSV/Excel-style rows for staff sign-in book bulk upload (name + optional role). */

import { normalizeStaffRole } from "./staffRoles";

export function parseStaffRosterCsvText(text) {
    const lines = String(text || "")
        .split(/\r?\n/)
        .map((line) => line.trim())
        .filter(Boolean);
    if (!lines.length) return { headers: [], rows: [] };

    const splitLine = (line) => {
        const cells = [];
        let current = "";
        let inQuotes = false;
        for (let i = 0; i < line.length; i += 1) {
            const ch = line[i];
            if (ch === '"') {
                inQuotes = !inQuotes;
                continue;
            }
            if ((ch === "," || ch === "\t") && !inQuotes) {
                cells.push(current.trim());
                current = "";
                continue;
            }
            current += ch;
        }
        cells.push(current.trim());
        return cells;
    };

    const headers = splitLine(lines[0]).map((h) => h.toLowerCase());
    const rows = lines.slice(1).map((line) => {
        const cells = splitLine(line);
        const row = {};
        headers.forEach((header, index) => {
            row[header] = cells[index] ?? "";
        });
        return row;
    });
    return { headers, rows };
}

export function mapStaffRosterRows(rawRows) {
    return rawRows
        .map((row) => {
            const name = String(
                row.name || row["full name"] || row.fullname || row.staff || row.staffname || "",
            ).trim();
            const role = String(row.role || row.title || row.position || "").trim();
            return { name, role: normalizeStaffRole(role) };
        })
        .filter((row) => row.name);
}

export async function parseStaffRosterFile(file) {
    const name = String(file?.name || "").toLowerCase();
    const text = await file.text();

    if (name.endsWith(".csv") || name.endsWith(".txt")) {
        const { rows } = parseStaffRosterCsvText(text);
        if (!rows.length) {
            return mapStaffRosterRows(
                text
                    .split(/\r?\n/)
                    .map((line) => line.trim())
                    .filter(Boolean)
                    .map((line) => {
                        const comma = line.indexOf(",");
                        if (comma > 0) {
                            return {
                                name: line.slice(0, comma).trim(),
                                role: line.slice(comma + 1).trim(),
                            };
                        }
                        return { name: line, role: "Staff" };
                    }),
            );
        }
        return mapStaffRosterRows(rows);
    }

    return mapStaffRosterRows(
        text
            .split(/\r?\n/)
            .map((line) => line.trim())
            .filter(Boolean)
            .map((line) => {
                const comma = line.indexOf(",");
                if (comma > 0) {
                    return {
                        name: line.slice(0, comma).trim(),
                        role: line.slice(comma + 1).trim(),
                    };
                }
                return { name: line, role: "Staff" };
            }),
    );
}

export function downloadStaffRosterTemplate() {
    const csv = "name,role\nJane Banda,Teacher\nJohn Phiri,Head of Department\nMary Mwale,Form Teacher\nGrace Zimba,Bursar\nPeter Nkosi,Librarian\n";
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = "staff-sign-in-template.csv";
    link.click();
    URL.revokeObjectURL(url);
}
